// La middleware 02.store.global.ts ne protège que la navigation (elle s'exécute
// uniquement au changement de route). Si selectedCrossDiag devient undefined pendant
// que l'utilisateur reste sur une page déjà chargée (ex: purge/suppression du
// diagnostic courant côté admin), les stores continuent d'appeler le backend avec
// "diagnosticId=undefined" tant qu'aucune navigation n'a lieu. Ce plugin réagit en
// temps réel à ce changement d'état pour rediriger immédiatement vers /choose-diag.
export default defineNuxtPlugin(() => {
    const decathStore = useDecathlonStores()
    const route = useRoute()

    const exemptRoutes = ['/welcome', '/choose-diag', '/admin/choose-diag']

    watch(() => decathStore.selectedCrossDiag, (crossDiag) => {
        if (!crossDiag && decathStore.selectedStore && !exemptRoutes.includes(route.fullPath)) {
            navigateTo(route.fullPath.startsWith('/admin') ? '/admin/choose-diag' : '/choose-diag')
        }
    })
})
